export default {
  name: 'FileRoom',
  id: 'FileRoom',
  data: [
    {
      title: 'Valuable data resides on this server.',
      icon1: '/static/svgs/commercial/file-room.svg',
      icon2: '/static/svgs/commercial/file-room.svg',
      answers: [
        'Ensure your server is protected and backed up in another location.'
      ],
      correctAnswerIndex: 0,
      position: {
        x: -0.5,
        y: -0.6,
        z: 0.5
      },
      completed: false
    }
  ]
};



// WEBPACK FOOTER //
// ./src/assets/questionsData/commercial/firstFloor/FileRoom.js